import React, { createContext, FC, useMemo, useReducer } from 'react';
import { noop } from 'lodash';

interface ModalState {
  isOpen: boolean;
  id: string | null;
}

type ModalAction =
  | {
      type: 'OPEN_MODAL';
      payload: { id: string };
    }
  | { type: 'CLOSE_MODAL' };

interface ModalProviderProps {
  initialStateOverride?: Partial<ModalState>;
}

const initialState: ModalState = {
  isOpen: false,
  id: null,
};

const reducer = (state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        ...state,
        isOpen: true,
        id: action.payload.id,
      };
    case 'CLOSE_MODAL':
      return initialState;
    default:
      return state;
  }
};

export const AddToProjectModalContext = createContext<{
  state: ModalState;
  dispatch: React.Dispatch<ModalAction>;
}>({
  state: initialState,
  dispatch: noop,
});

export const AddToProjectModalProvider: FC<ModalProviderProps> = ({
  initialStateOverride = {},
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...initialStateOverride,
  });

  const value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <AddToProjectModalContext.Provider value={value}>
      {children}
    </AddToProjectModalContext.Provider>
  );
};
